import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/website/salontymwebweb/app/[hub]/[category]/ServiceViewContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/website/salontymwebweb/app/components/footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AllCartsSlideCategory"] */ "/home/ec2-user/website/salontymwebweb/app/components/genericComponents/all-carts/AllCartsSlideCategory.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartButton"] */ "/home/ec2-user/website/salontymwebweb/app/components/genericComponents/card/cartButton/CartButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuSubCategory"] */ "/home/ec2-user/website/salontymwebweb/app/components/genericComponents/menu/MenuSubCategory.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/website/salontymwebweb/app/components/genericComponents/services-slider/SubCategoryCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavbarWraper"] */ "/home/ec2-user/website/salontymwebweb/app/components/navbar/NavbarWraper.tsx");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/website/salontymwebweb/node_modules/@mui/material/Box/index.js");
